module.exports = __webpack_public_path__ + "img/chinesecompany189.7e901f6a.png";